import React from 'react';
import { StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-cream px-5 py-16 sm:px-8 md:py-20" data-id="element-246" data-mp="3fznvbprkvj3h">
      <div className="mx-auto max-w-3xl text-center" data-id="element-247" data-mp="3fxuni758astw">
        <h2 className="font-display text-[26px] font-bold leading-tight text-ink sm:text-4xl" data-id="element-248" data-mp="3b1ckpctgl4k7">
          ⭐ What dentists are saying
        </h2>
        <div className="mt-4 flex items-center justify-center gap-2" data-id="element-249" data-mp="370ajwrjw8kg4">
          <span className="flex" aria-hidden="true" data-id="element-250" data-mp="31yv0f3xd6lzu">
            {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="h-5 w-5 fill-gold text-gold" data-id="element-251" data-mp="2x1kzar0m4lw6" />)}
          </span>
          <span className="font-display text-xl font-bold text-ink" data-id="element-252" data-mp="2s3079evil8it">4.9/5</span>
        </div>
        <p className="mx-auto mt-3 max-w-lg text-[13px] leading-relaxed text-clay" data-id="element-253" data-mp="v8591v8ft91q">
          Experiences from dentists using structured planning and clinical reference systems.
        </p>
      </div>

      <ul className="mx-auto mt-10 grid max-w-4xl gap-4 md:grid-cols-2" data-id="element-254" data-mp="h55a40zwdtwk">
        {testimonials.map(testimonial => <li key={testimonial.name} className="flex h-full flex-col rounded-3xl border border-ink/10 bg-white p-5 sm:p-6" data-id="element-255" data-mp="m6cia15ycv3r">
            <div className="flex items-center gap-3" data-id="element-256" data-mp="c625ghntxpp4">
              <img src={testimonial.photo} alt={`${testimonial.name}, ${testimonial.role}`} className="h-14 w-14 shrink-0 rounded-full object-cover" width={112} height={112} data-id="element-257" data-mp="c8ok119515gu" />
              <div data-id="element-258" data-mp="q63e4jac61f5">
                <p className="text-[15px] font-bold text-ink" data-id="element-259" data-mp="q4jxusoojqdd">
                  {testimonial.name} <span aria-hidden="true" data-id="element-260" data-mp="v3wkbcbn2vff">{testimonial.flag}</span>
                </p>
                <p className="text-[12px] font-semibold uppercase tracking-[0.08em] text-clay" data-id="element-261" data-mp="1iuiimbvud1c8">
                  {testimonial.role}
                </p>
              </div>
            </div>
            <div className="my-4 hairline" data-id="element-262" data-mp="1xgxuuxwfnlgm" />
            <blockquote className="text-[15px] leading-relaxed text-ink/85" data-id="element-263" data-mp="1xfmtt5udgrt7">
              “{testimonial.quote}”
            </blockquote>
          </li>)}
      </ul>

      <div className="mx-auto mt-10 max-w-xl" data-id="element-264" data-mp="1ofrh2wl64or2">
        <CtaButton label="I want to use Resin Architect™" data-id="element-265" data-mp="1jihppbe7y30l" />
      </div>
    </section>;
}